export const COLORS_PALETTE = {
  FIRST: '#3787BF',
  SECOND: '#3c8dbc',
  THIRD: 'TBD',
  FOURTH: 'TBD',
  FITH: 'TBD'
}
